//Load thu vien
import 'babel-polyfill';
import Vue from 'vue';
import Router from 'vue-router';
import VueResource from 'vue-resource';
import VueLodash from 'vue-lodash';
import Toasted from 'vue-toasted';
import VueScrollTo from 'vue-scrollto';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueTheMask from 'vue-the-mask';
import Datepicker from 'vuejs-datepicker';
import { Datetime } from 'vue-datetime';
import { Settings } from 'luxon'
import 'vue-datetime/dist/vue-datetime.css'
const dateFormat = require("dateformat");
const ip = require("ip");
Settings.defaultLocale = 'vi'

//import './assets/css/fonts.css'
import store from "./store";


import VueGeolocation from 'vue-browser-geolocation';
Vue.use(VueGeolocation);
export const bus = new Vue();


//Global variables
Vue.prototype.$foodbookConfig =  {
    api: wzFoodbookData.foodbookapi || "https://api.foodbook.vn/ipos/ws/",
    pos_name: wzFoodbookData.pos_name || "SAOBANG",
    pos_id: wzFoodbookData.pos_id || 0,
    pos_data: wzFoodbookData.pos_data || null,
    wpapi: wzFoodbookData.restapi || null,
    imageDefault: wzFoodbookData.imageDefault || null,
    imageDefaultCombo:wzFoodbookData.imageDefaultCombo,// "http://localhost/suonmuoi/wp-content/plugins/wz-foodbook/assets/images/default_combo.png",
    logo: wzFoodbookData.logo || null,
    googleMapApi: wzFoodbookData.maps_api || null,
    time_range: 30, //Khoảng thời gian giao hàng
    timeLimit: 3, //Chỉ giao trong khoang thoi gian x ngay
    fbAppId: wzFoodbookData.facebookapi,
    hotline: wzFoodbookData.hotline,
    homepage : wzFoodbookData.homepage,
    menupage : wzFoodbookData.menupage,
    checkoutpage : wzFoodbookData.checkoutpage,
    orderpage : wzFoodbookData.orderpage,
    loginpage : wzFoodbookData.loginpage,
    profilepage: wzFoodbookData.profilepage,
    voucherpage: wzFoodbookData.voucherpage,
    customerpage: wzFoodbookData.customerpage,
    bookingpage: wzFoodbookData.bookingpage,
    registerpage: wzFoodbookData.registerpage,
    user_phone: wzFoodbookData.user_phone || 0,
    userId: wzFoodbookData.userId || 0,
};

Vue.prototype.$payments = {
    vnpay:{
        enable:wzFoodbookData.vnpay_enable || false,
        tmnCode: wzFoodbookData.vnpay_tmnCode,
        secretKey: wzFoodbookData.vnpay_secretKey,
        vnpUrl:wzFoodbookData.vnpay_vnpUrl,
        returnUrl: wzFoodbookData.checkoutpage,
    }
};


//Su dung cac thu vien
Vue.use(Router)
Vue.use(VueResource);
Vue.use(Toasted);
Vue.use(VueScrollTo);
Vue.use(VueTheMask);
Vue.use(VueLodash, {
    name: 'custom',
    lodash : {

    }
});
Vue.use(VueGoogleMaps, {
    load: {
        key: Vue.prototype.$foodbookConfig.googleMapApi,
        libraries: 'places',
    },
});

import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
Vue.use(PerfectScrollbar)

Vue.prototype.$globalLib = {
    dateFormat:dateFormat,
    ip:ip.address()
};

//Config
Vue.config.productionTip = true;

if(localStorage.cart){
    Vue.prototype.$cart = JSON.parse(localStorage.cart)
}else{
    Vue.prototype.$cart = {
        shipment: null, // kiểu đặt món: giao hàng / đến lấy hàng
        restaurant: null, // vị trí nhà hàng đã chọn
        coupon_log_id: '',
        coupon_status: '',
        user_id: null,
        username: null,
        note: null,
        longitude: null,
        latitude: null,
        to_address: null,
        delivery_time_type: null,
        delivery_time_date: null,
        delivery_time_hour: null,
        province: null,
        district: null,
        ship_price_real: null,
        distance: null,
        payment:"COD",
        amount: null,
        total_amount: null,
        order_type: 'DELI',
        PaymentInfo: {
            Payment_Method: "PAYMENT_ON_DELIVERY",
            Payment_Info: "1",
            Amount: 0
        },
        ordersItem:[]
    };
}

//Load component
import Login from './components/OldLogin';
import Menu from './components/Menu';
import ModalProduct from './components/ModalProduct';
import Checkout from './components/Checkout';
import Order from './components/Order';
import Header from './components/Header';
import Profile from './components/Profile';
import UpdateProfile from './components/UpdateProfile';
import SetAddress from './components/SetAddress';
import Booking from './components/Booking';
import Register from './components/Register';
import Voucher from './components/voucher';

//Global component
Vue.component('datetime', Datetime);
Vue.component('modal-product',ModalProduct);
Vue.component('google-map', VueGoogleMaps.Map);
Vue.component('google-marker', VueGoogleMaps.Marker);
Vue.component('datepicker', Datepicker);



//Global filter
Vue.filter('formatPrice', function (value) {
    let val = (value / 1).toFixed(0).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' vnđ';
});
Vue.filter('formatPrice2', function (value) {
    let val = (value / 1).toFixed(0).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
});
Vue.filter('totalPrice', function (cart) {
    if(cart && cart.ordersItem.length){
        let total = 0;
        for(let i=0 ;i<cart.ordersItem.length;i++){
            let item = cart.ordersItem[i];
            total +=  (item.order.Price + item.order.plusPrice) * item.order.Quantity;
        }


        let val = (total / 1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' vnđ';
    }
    return '0 vnđ';
});
Vue.filter('totalPriceCart', function (cart) {
    let total = 0;
    if(cart && cart.ordersItem.length){
        for(let i=0 ;i<cart.ordersItem.length;i++){
            let item = cart.ordersItem[i];
            total +=  (item.order.Price + item.order.plusPrice) * item.order.Quantity;
        }
    }

    if(cart.ship_price_real && cart.ship_price_real > 0){
        total += cart.ship_price_real
    }

    if(cart.Discount_Amount){
        total -= cart.Discount_Amount
    }


    let val = (total / 1).toFixed(0).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' vnđ';
});
Vue.filter('totalPricePayment', function (cart) {
    let total = 0;
    if(cart && cart.ordersItem.length){
        for(let i=0 ;i<cart.ordersItem.length;i++){
            let item = cart.ordersItem[i];
            total +=  (item.order.Price + item.order.plusPrice) * item.order.Quantity;
        }
    }

    if(cart.order_type !== 'PICKUP' && cart.ship_price_real && cart.ship_price_real > 0){
        total += cart.ship_price_real
    }

    if(cart.Discount_Amount){
        total -= cart.Discount_Amount
    }


    return total;
});
Vue.filter('totalPriceNotFormat', function (cart) {
    if(cart && cart.ordersItem.length){
        let total = 0;
        for(let i=0 ;i<cart.ordersItem.length;i++){
            let item = cart.ordersItem[i];
            total +=  (item.order.Price + item.order.plusPrice) * item.order.Quantity;
        }
      if( (cart.order_type === 'DELI' || cart.order_type === 'DELIAT')
        && cart.ship_price_real && cart.ship_price_real > 0){
        total += cart.ship_price_real
      }
        return total;
    }
    return 0;
});
Vue.filter('countTotalItems', function (cart) {
    if(cart && cart.ordersItem.length){
        let total = 0;
        for(let i=0 ;i<cart.ordersItem.length;i++){
            let item = cart.ordersItem[i];
            total += item.order.Quantity;
        }
        return total;
    }
    return 0;
});
Vue.filter('renderOrderItems', function (cart) {
    let items = [];
    if(cart && cart.ordersItem.length){
        for(let i=0 ;i<cart.ordersItem.length;i++){
            let item = cart.ordersItem[i].order;
            let product_data = cart.ordersItem[i].product;
            let notes = [];

            if(item.options) {
              if (item.isCombo) {
                _.forEach(item.options, (val, key) => {
                  _.forEach(val.details, (detail, index) => {
                    if (detail.Item_Id === val.selected) {
                      let productInCombo = {
                        "Item_Type_Id": detail.Item_Type_Id,
                        "Item_Id": detail.Item_Id,
                        "Item_Name": detail.Item_Name,
                        "Price": 0,//val.ta_price,
                        "Amount": 0,//val.ta_price,
                        "Quantity": 1,
                        "Note": "",
                        "mDiscount": 0,
                        "fix": 1,
                        "Package_Id": item.Package_Id
                      };
                      items.push(productInCombo);
                    }
                  });
                });
              } else {
                _.forEach(item.options, (val, key) => {
                  if (val.options.length) {
                    let noteText = val.name + ': ' + _.join(val.options, ', ');
                    notes.push(noteText);
                  }
                })
              }

            } // item.options

            if(item.Note){
                notes.push(item.Note);
            }

            let product = {};
            let option_products = [];

          if (item.isCombo) {
            product = {
              "Item_Type_Id": item.Item_Type_Id,
              "Item_Id": item.Item_Id,
              "Item_Name": item.Item_Name,
              "Price": item.Price,
              "Amount": (parseFloat(item.Price) + parseFloat(item.plusPrice)) * item.Quantity,
              "Quantity": item.Quantity,
              "Discount": item.Discount,
              "Package_Id": item.Package_Id
            }
          } else {
            console.log('Sản phẩm có customizations ')
            product = {
              "Item_Type_Id": item.Item_Type_Id,
              "Item_Id": item.Item_Id,
              "Item_Name": item.Item_Name,
              "Price": item.Price,
              "Amount": parseFloat(item.Price) * item.Quantity,
              "Quantity": item.Quantity,
              "Note": "",
              "Discount": item.Discount
            }

            // tính thêm các options
            //console.log('tạo sp options',item)
            _.each(item.options, (opt, key) => {
              let {customizations} = product_data

              // customizations case
              if (customizations && opt.min === 1 && opt.max === 1) {
                let o = _.find(customizations[key].options, function (obj) {
                  return obj.name === opt.options[0];
                });
                //console.log(opt.min,opt.model)
                if (o) {
                  let {store_item_id} = product_data;
                  store_item_id = store_item_id != null ? store_item_id : '';

                  let _opt = {
                    "Item_Type_Id": "",
                    "Item_Id": o.id,
                    "Item_Name": o.name,
                    "Price": o.ta_price,
                    "Amount": parseFloat(o.ta_price) * item.Quantity,
                    "Quantity": item.Quantity,
                    "Note": "Option " + key,
                    "Parent_Id": store_item_id,
                    "parent_id": store_item_id,
                    "Discount": 0
                  }
                  option_products.push(_opt);
                }
              } else {
                if (opt.model) {
                  _.forEach(opt.model, op => {
                    if (op.quantity > 0) {
                      let _op = {
                        "Item_Type_Id": "",
                        "Item_Id": op.id,
                        "Item_Name": op.name,
                        "Price": op.price,
                        "Amount": parseFloat(op.price) * item.Quantity,
                        "Quantity": op.quantity * item.Quantity,
                        "Note": "",
                        "Discount": 0
                      }
                      option_products.push(_op);
                    }
                  });
                }
              }


            });
          }

          items.push(product);

          // thêm option (topping)
          if (option_products.length) {
            _.forEach(option_products, opt => {
              items.push(opt);
            })
          }

        } // for
    }
    return items;
});


var router = new Router({
    mode: 'history',
    routes: []
});
new Vue({
    router,
    store,
    el: '#wiz-foodbook',
    components: {
        login: Login,
        'menu-items': Menu,
        checkout: Checkout,
        order: Order,
        'header-foodbook': Header,
        profile: Profile,
        'update-profile': UpdateProfile,
        'set-address':SetAddress,
        'booking':Booking,
        'register':Register,
        'voucher':Voucher,
    },
    data() {
        return {
            search: '',
        }
    },
    methods:{
        updateSearchFnc(val){
            this.search =  val;
        }
    }
});




// WEBPACK FOOTER //
// ./src/main.js